module.exports={WINGS_URL:'https://api.rexsoftware.com/rex.php',API_URL:'https://imports-api.rexsoftware.com/api',PUSHER_KEY:'4529d4f295a1bc474f38',PUSHER_CLUSTER:'ap4',SEGMENT_ID:'5bobpBu7HL0EP3RU9RtCqC5lCumcvbV3'};
